import React, {useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Paper, Typography, Button, Container } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { CanvasContext } from '../contexts/CanvasContext';

const layouts = [
  { id: 0, name: 'Skier', imageSrc: 'assets/48_ski.png', type: 'skier' },
  { id: 1, name: 'Mino', imageSrc: 'assets/mino.png', type: 'mino' },
  { id: 2, name: 'House Cleaning', imageSrc: 'assets/housecleaning.png', type: 'housecleaning' },
  { id: 3, name: 'Baby', imageSrc: 'assets/baby.png', type: 'baby' },
  { id: 4, name: 'Sweet Home', imageSrc: 'assets/sweethome.png', type: 'sweethome' },
  { id: 5, name: 'Skier SVG', imageSrc: 'assets/skier.svg', type: 'skiersvg' },
];

const LayoutSelection = () => {

  const {  setLayers,
    
} = useContext(CanvasContext);

  const navigate = useNavigate();
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMdScreen = useMediaQuery(theme.breakpoints.between('md', 'lg'));

  // Determine grid size based on screen size
  const getGridSize = () => {
    if (isXsScreen) return 12; // Full width on mobile
    if (isSmScreen) return 4;  // 2 cards per row on small tablets
    if (isMdScreen) return 2;  // 3 cards per row on larger tablets
    return 1.8;                // ~5 cards per row on desktop (original layout)
  };

  const handleLayoutSelect = async (type) => {
    navigate(`/canvas?type=${type}`);

    setLayers([]);

  };

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom align="center" sx={{ mb: 4 }}>
        Select a Layout
      </Typography>
      <Grid container columnSpacing={2} rowSpacing={6}>
        {layouts.map((layout) => (
          <Grid item xs={getGridSize()} key={layout.id}>
            <Paper 
              elevation={2} 
              sx={{
                p: 2,
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
            >
              <div>
                <img 
                  src={layout.imageSrc}
                  alt={layout.name}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    margin: '0.5em auto',
                    display: 'block'
                  }}
                />
              </div>
              <Button 
                variant="outlined" 
                color="primary" 
                fullWidth
                onClick={() => handleLayoutSelect(layout.type)}
                sx={{ mt: 1 }}
              >
                <Typography>
                  {layout.name}
                </Typography>
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default LayoutSelection;